import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
export const Spinner = ({ size = "medium", className, ...rest }) => {
    return (_jsx(_Fragment, { children: _jsx("div", { className: classNames("eds-spinner", `eds-spinner--${size}`, className), ...rest, children: _jsx("span", { className: "eds-hidden--screen-reader-only", children: "Loading..." }) }) }));
};
